import React from "react";
import MUIDataTable from "mui-datatables";

import {
  createMuiTheme,
  MuiThemeProvider
} from "@material-ui/core/styles";

import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';

import Button from '@material-ui/core/Button';

import  api from '../common/api';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { Fab } from "@material-ui/core";
import SpeedIcon from "@material-ui/icons/Speed";
import VehicleKmSubcontact from "../vehicles/VehicleKmSubcontact";
  //import { Store } from "../../flux";
  
class ContractsVehicles extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        param:'',
        contact_id: '',
        contract_name: '',
        isLoaded: false,
        km_subcontact_dialog: {open: false, plate: '', id:''},
      
      }
    }

    componentDidMount() {
      const param = this.getParams().query
      this.setState({contract_id: param})
      this.getContract(param).then(result => {
        var contract_name = result[0] ? result[0].name : '';
        var data = result[0] ? result[0].vehicles : ''
        if (param === '0'){
          contract_name = 'AutoCorp'
          data = result ? result : []
        }
        this.setState({
          contract_name:  contract_name,
          data: data
        })          
    })
    }
   
   getParams(location) {
      const searchParams = new URLSearchParams(window.location.search);
      return {
        query: searchParams.get("id")
      };
    } 

   getContract = (contract_id) => {
       const token =localStorage.getItem('userToken')
       var url = api.contract().get(contract_id);
       if (contract_id == 0)
        url = api.vehicles().indexAc()
       return axios
            //.get(`${api.contracts}/${contract_id}`,
            .get(url,{ headers: {"Authorization" : `Bearer ${token}`} })
            .then(res => {
              this.setState({isLoaded: true})
              return res.data
            })
            .catch(err =>{console.log(err)
            })
      }
  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
         root: {
           padding: '8px 8px 8px 8px',
          }
        }
      }
  });

  handleKmDialog = (e, plate, id) => {
    var km_subcontact_dialog = this.state.km_subcontact_dialog
    km_subcontact_dialog.open = !km_subcontact_dialog.open
    km_subcontact_dialog.plate = (km_subcontact_dialog.open) ? plate : ''
    km_subcontact_dialog.id = (km_subcontact_dialog.open) ? id : ''
    this.setState({km_subcontact_dialog})
  }

  render(){

     const columns = [
     {
      name: "id",
      label: "Id",
      options: {
       filter: false,
       sort: true,
      }
     },
     {
      name: "plate",
      label: "Patente",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "description",
      label: "Descripción",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
       customBodyRender: (value, tableMeta, updateValue) => {
          return (
            tableMeta.rowData[5] + ' ' + tableMeta.rowData[6] + ' ' + tableMeta.rowData[7]
          )
        }
      }
     }
     ,
     {
      name: "hansa_start_date",
      label: "Fecha desde",
      options: {
       filter: false,
       sort: true,
      }
     },
     {
      name: "hansa_end_date",
      label: "Fecha hasta",
      options: {
       filter: false,
       sort: false,
       display: false,
      }
     },
     {
      name: "version.variation.brand.name",
      label: "Marca",
      options: {
       filter: false,
       sort: false,
       display: false,
      }
     },
     {
      name: "version.variation.dnrpa_description",
      label: "Modelo",
      options: {
       filter: false,
       sort: false,
       display: false,
      }
     },
     {
      name: "version.name",
      label: "version",
      options: {
       filter: false,
       sort: false,
       display: false,
      }
     },
     {
      name: "Acciones",
      label: "",
      options: {
          filter: false,
          setCellHeaderProps: () => ({ align: 'right' }),
          customBodyRender: (value, tableMeta, updateValue) => {
            const rowId = tableMeta.rowData[0]
            const plate = tableMeta.rowData[1]
            //const rowId = 1
            return (
              <div className="row" style={{display: 'inline-table', textAlign: 'right', paddingRight: '20px'}}>
                <Fab color="primary" aria-label="view" variant="extended" style={{boxShadow: 'none' }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-1'  onClick={(e) => {this.handleKmDialog(e, plate, rowId)}}>
                  <SpeedIcon fontSize="small" /> 
                </Fab>
              </div>
                )}
          }
    }
    ];

  var import_url = "vehicles/"+this.state.contract_id+"/0/1/import"
  if (this.state.contract_id === '0'){
    import_url+="/1"
  }

  const options = {
    filter: true,
    selectableRows: false,
    filterType: 'dropdown',
    responsive: 'stacked',
    rowsPerPage: 10,
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={"Importar"}>
            <IconButton onClick={(e)=>{window.location.href = import_url}}>
              <ImportExportIcon />
            </IconButton>
          </Tooltip>
      </React.Fragment>
      );
    },

    textLabels: {
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
                  toolTip: "Ordenar",
                  columnHeaderTooltip: column => `Ordenar para ${column.label}`

          },
      filter: {
        all: "Todos los resultados",
        title: "Tus filtros"  ,
        reset: "Resetear",          
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Exportar CSV",
        print: "Imprimir",
        viewColumns: "ver columnas",            
        filterTable: "Filtros",
      },
      pagination: {
        next: "Siguiente",
        previous: "Anteior",
        rowsPerPage: "Cantidad por página:",
        displayRows: "de",      
      },
      selectedRows: {
        text: "fila(s) seleccionadas",
      },
    }    };

   return(
    <div>
   <MuiThemeProvider theme={this.getMuiTheme()}>

    <MUIDataTable
      title={`Lista de Vehículos ${this.state.contract_name}`}
      data={Object.values(this.state.data)}
      columns={columns}
      options={options}
     />
    {this.state.km_subcontact_dialog.plate && <VehicleKmSubcontact plate={this.state.km_subcontact_dialog.plate} open={this.state.km_subcontact_dialog.open} handleKmDialog={this.handleKmDialog} id={this.state.km_subcontact_dialog.id}/>}

    </MuiThemeProvider>
           <div style={{textAlign: "right"}}>
         <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/contracts"}>
            Volver
        </Button>
      </div>
    </div>

    );
  }

}

export default ContractsVehicles;   